import { AUTH, AUTH_LOGIN, AUTH_LOGOUT, AUTH_TOKEN } from '@store/types'
import { toFormData } from '@helpers/cast'
import axios from 'axios'
import shortly from 'vuex-shortly'
import decode from 'jwt-decode'
import router from '@router'

const state = {
  token: null,
  expires_at: null
}

const getters = {
  [AUTH]: (state) => state,
  [AUTH_TOKEN]: (state) => state.token
}

const mutations = {
  [AUTH_TOKEN]: (state, payload) => {
    state.token = payload.token
    state.expires_at = payload.exp * 1000
  }
}

const actions = {
  [AUTH_LOGIN]: async ({ commit }, payload) => {
    const data = toFormData(payload)
    const response = await axios.post('/authenticate', data)

    if (+response?.status !== 200) {
      throw new Error('E-Mail e/ou senha não encontrados!')
    }

    const token = response.data?.token
    const { exp } = decode(token)

    commit(AUTH_TOKEN, { token, exp })
  },

  [AUTH_LOGOUT]: ({ commit }) => {
    commit(AUTH_TOKEN, {
      token: null,
      exp: null
    })
    router.push({ name: 'Login' })
  },

  [AUTH_TOKEN]: ({ commit }, payload) => {
    commit(AUTH_TOKEN, payload)
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/auth.js